var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenuChallengesInactive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.333 1H6.33301V7.71659C6.33301 10.9546 8.16246 13.9147 11.0586 15.3628C11.8609 15.7639 12.8051 15.7639 13.6074 15.3628C16.5036 13.9147 18.333 10.9546 18.333 7.71659V1Z",
    stroke: "#24284E",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.333 23H5.33301V22.3188C5.33301 21.5187 5.8098 20.7957 6.54517 20.4805L7.60598 20.0259C10.6246 18.7322 14.0415 18.7322 17.06 20.0259L18.1208 20.4805C18.8562 20.7957 19.333 21.5187 19.333 22.3188V23Z",
    stroke: "#24284E",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.333 4H23.333C23.333 11.2 21.833 13 21.833 13",
    stroke: "#24284E",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.33301 4H1.33301C1.33301 11.2 2.83301 13 2.83301 13",
    stroke: "#24284E",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.333 16V19",
    stroke: "#24284E",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuChallengesInactive);
export default __webpack_public_path__ + "static/media/menu-challenges-inactive.f41bcd03b4aba69a19622e612622738f.svg";
export { ForwardRef as ReactComponent };